import { useState } from 'react';

import { Modal, UploadProps } from 'antd';
import { RcFile, UploadFile } from 'antd/lib/upload';
import { FileUploader } from 'components';
import { useMessageLogger } from 'hooks/useMessageLogger';
import { usersApi } from 'services/rtk/users';

interface Props {
  isModalVisible: boolean;
  setIsModalVisible: (state: boolean) => void;
  userId: number;
}

const UploadAvatarModal = ({ isModalVisible, setIsModalVisible, userId }: Props) => {
  const [files, setFiles] = useState<UploadFile[]>([]);
  const [uploadImage, { error, status }] = usersApi.useUploadAvatarMutation();

  const onSuccess = () => {
    setIsModalVisible(false);
    setFiles([]);
  };

  const onModalCancel = () => {
    setIsModalVisible(false);
    setFiles([]);
  };

  const handleOk = () => {
    files.length && uploadImage({ userId, avatar: files[0] as RcFile });
  };

  useMessageLogger({
    error,
    status,
    successMessage: 'Аватар обновлен',
    onSuccess,
  });

  return (
    <Modal open={isModalVisible} onCancel={onModalCancel} onOk={handleOk} width={700}>
      <ImageUploader files={files} setFiles={setFiles} />
    </Modal>
  );
};

interface ImageUploaderProps {
  files: UploadFile[];
  setFiles: React.Dispatch<React.SetStateAction<UploadFile[]>>;
}

const ImageUploader = ({ files, setFiles }: ImageUploaderProps) => {
  const beforeUpload: UploadProps['beforeUpload'] = (file, files) => {
    setFiles([file]);
    return false;
  };

  return (
    <FileUploader
      files={files}
      setFiles={setFiles}
      disabled={files.length >= 1}
      beforeUpload={beforeUpload}
      multiple={false}
      hintMessage={'- Максимальный размер файла 5 МБ'}
      style={{ marginTop: 30 }}
    />
  );
};

export default UploadAvatarModal;
